import {
  ALERT_CREATE,
  ALERT_DELETE,
  ALERT_EDIT,
  ALERT_STATUS,
  ALERT_TABLE,
  ALERT_VIEW,
} from "../types";

export const alertCreateAction = (data, onSuccess, onError) => {
  return {
    type: ALERT_CREATE,
    data,
    onSuccess,
    onError,
  };
};

export const alertTableAction = (data, onSuccess, onError) => {
  return {
    type: ALERT_TABLE,
    data,
    onSuccess,
    onError,
  };
};

export const alertViewAction = (data, onSuccess, onError) => {
  return {
    type: ALERT_VIEW,
    data,
    onSuccess,
    onError,
  };
};
export const alertEditAction = (data, onSuccess, onError) => {
  return {
    type: ALERT_EDIT,
    data,
    onSuccess,
    onError,
  };
};
export const alertDeleteAction = (data, onSuccess, onError) => {
  return {
    type: ALERT_DELETE,
    data,
    onSuccess,
    onError,
  };
};
export const alertStatusAction = (data, onSuccess, onError) => {
  return {
    type: ALERT_STATUS,
    data,
    onSuccess,
    onError,
  };
};
